import { createContext } from 'react';

export const SalesforceContext = createContext(null);
